import React from 'react';
import './Login.scss';  
import row from "../../../Assets/image (58).png";
import logo from "../../../Assets/image (90).png";
import sidelogo from "../../../Assets/image (59).png";
import { Link } from 'react-router-dom';

export default function Login() {
  return (
 
        <div className="login-form-container">
          <h2 className="login-title">Hello Again!</h2>
<p className='login-p'>Welcome Back</p>
          <div className="login-input-group">
            <i className="fa-regular fa-envelope"></i>
            <input type="text" placeholder="Email Address" />
          </div>

          <div className="login-input-group">
            <i className="fa-solid fa-lock"></i>
            <input type="password" placeholder="Password" />
          </div>

          <button className="login-button">Login</button>
          <Link className="Link" to={"/forgetpassword"}>
  <p className="login-forgot">Forgot Password</p>
</Link>
         
        </div>
     
  
  );
}
